import Api from '@/services/Api'
import { baseURL } from '@/services/config'

// Status servisa za kupca: QR kod s male trake servisnog naloga vodi na javnu
// stranicu s tim statusom (SQL A12).
export default {
  // Token naloga (napravi ga ako ga nema). {CompanyId, id}
  token (dokument) {
    return Api().post('servis/token', dokument)
  },

  /**
   * Puna adresa javne stranice.
   *
   * ZASTO se gradi ovdje: ista aplikacija radi na vise servera
   * (app.roboot.net, app.cegrupa.com, app.ceusluge.com...), a program NE zna
   * na kojem je - u postavkama toga nema. Preglednik zna: "baseURL" je na
   * produkciji relativan ("./backend/"), pa ga treba razrijesiti prema adresi
   * s koje je aplikacija ucitana. Tako je poveznica na svakom serveru ispravna
   * sama po sebi, bez ikakve postavke.
   */
  javnaAdresa (putanja) {
    const osnova = new URL(baseURL, window.location.href).href
    return osnova.replace(/\/+$/, '') + '/' + String(putanja).replace(/^\/+/, '')
  }
}
